import AssetSymbol from './AssetSymbol';

export default AssetSymbol;